import * as React from "react"
import { Spinner, Paper } from "components"
import classnames from "classnames"
import "./card.scss"

type Card = CardHeader & Paper

const Card: React.FC<Card> = ({
	title,
	children,
	className,
	loading,
	...rest
}) => {
	return (
		<Paper className={classnames("card-component", className)} {...rest}>
			<CardHeader title={title} loading={loading} />
			{children}
		</Paper>
	)
}

interface CardHeader {
	title: string
	loading?: boolean
}

const CardHeader: React.FC<CardHeader> = ({ title, loading = false }) => {
	return (
		<div className="d-flex align-items-center justify-content-between">
			<h1 className="card__header">{title}</h1>
			{loading && <Spinner />}
		</div>
	)
}

export default Card
